module.exports = __webpack_public_path__ + "static/img/手写申明（修改注册信息--修改表）.6f16be3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/手写申明（修改注册信息--修改表）.jpg
// module id = HJNu
// module chunks = 0